import {
    ArrowLeftRight,
    Building2,
    Calculator,
    Coins,
    DollarSign,
    Eye,
    FileIcon,
    FileText,
    Gauge,
    Gavel,
    GitBranch,
    Info,
    Landmark,
    Layers,
    Link2,
    Repeat,
    Scale,
    Shield,
    Store,
    TrendingUp,
    Users,
} from "lucide-react";

// // // //

// Map ReferenceData.color and Measure.color to text classname
export const MAP_COLOR_TO_TEXT_CLASS_NAME = {
    amber: "text-amber-500",
    blue: "text-blue-500",
    cyan: "text-cyan-500",
    emerald: "text-emerald-500",
    indigo: "text-indigo-500",
    orange: "text-orange-500",
    purple: "text-purple-500",
    red: "text-red-500",
    rose: "text-rose-500",
    sky: "text-sky-500",
    slate: "text-slate-500",
    teal: "text-teal-500",
    violet: "text-violet-500",
    yellow: "text-yellow-500",
};

// Map ReferenceData.color and Measure.color to a subtle background classname
// (pairs with MAP_COLOR_TO_TEXT_CLASS_NAME for tinted icon badges)
export const MAP_COLOR_TO_BG_CLASS_NAME = {
    amber: "bg-amber-500/10",
    blue: "bg-blue-500/10",
    cyan: "bg-cyan-500/10",
    emerald: "bg-emerald-500/10",
    indigo: "bg-indigo-500/10",
    orange: "bg-orange-500/10",
    purple: "bg-purple-500/10",
    red: "bg-red-500/10",
    rose: "bg-rose-500/10",
    sky: "bg-sky-500/10",
    slate: "bg-slate-500/10",
    teal: "bg-teal-500/10",
    violet: "bg-violet-500/10",
    yellow: "bg-yellow-500/10",
};

// Full-opacity variant of MAP_COLOR_TO_BG_CLASS_NAME, for solid fills
// (e.g. progress bars) rather than subtle tinted backgrounds
export const MAP_COLOR_TO_SOLID_BG_CLASS_NAME = {
    amber: "bg-amber-500/60",
    blue: "bg-blue-500/60",
    cyan: "bg-cyan-500/60",
    emerald: "bg-emerald-500/60",
    indigo: "bg-indigo-500/60",
    orange: "bg-orange-500/60",
    purple: "bg-purple-500/60",
    red: "bg-red-500/60",
    rose: "bg-rose-500/60",
    sky: "bg-sky-500/60",
    slate: "bg-slate-500/60",
    teal: "bg-teal-500/60",
    violet: "bg-violet-500/60",
    yellow: "bg-yellow-500/60",
};

// Map ReferenceData.icon and Measure.icon to Lucide icon component
export const MAP_ICON_TO_LUCIDE_ICON = {
    arrow_left_right: ArrowLeftRight,
    building: Building2,
    calculator: Calculator,
    coins: Coins,
    dollar_sign: DollarSign,
    eye: Eye,
    gavel: Gavel,
    info: Info,
    landmark: Landmark,
    layers: Layers,
    link: Link2,
    scale: Scale,
    shield: Shield,
    store: Store,
    trending_up: TrendingUp,
    users: Users,
    git_branch: GitBranch,
    gauge: Gauge,
    repeat: Repeat,
    file: FileIcon,
    file_text: FileText,
};
